import { axiosPost } from '../../axios/axios.config';

export const detailAnalyticsData = (data: {start_date:string | null, end_date:string | null, daywise:boolean, pagepath:string | null}) => {
  return axiosPost("/api/v1/getanalytics", {start_date:data.start_date, end_date: data.end_date,daywise:data.daywise, pagepath:data.pagepath});
}